import React, { useState, useEffect } from 'react';

const Timer = (props) => {
	const { seconds, setIsTimerOver } = props;
	const [ counter, setCounter ] = useState(seconds);
	useEffect(
		() => {
			const timer =
				counter > 0 &&
				setInterval(() => {
					setCounter(counter - 1);
				}, 1000);
			return () => clearInterval(timer);
		},
		[ counter ]
	);
	return (
		<div className="Timer">
			<p>
				{Math.floor(counter / 60)}:{counter % 60 >= 10 ? counter % 60 : `0${counter % 60}`}
			</p>
		</div>
	);
};

export default Timer;
